import { Component, inject, isDevMode, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Store } from '@ngrx/store';
import { selectAdminOrganiser } from '../../../../data-services/stores/selectors/admin.selectors';
import { AsyncPipe, CommonModule } from '@angular/common';
import { adminActions, adminApiActions } from '../../../../data-services/stores/actions/admin.actions';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { tap } from 'rxjs';
import { FileUploadModule, UploadEvent } from 'primeng/fileupload';
import { HttpHeaders, HttpResponse } from '@angular/common/http';
import { environment } from '../../../../../environments/environment';
import { AuthService } from '../../../../data-services/auth.service';
import { CloudinaryImg } from '../../../../data-services/models/cloudinary-image.model';
import { Editor } from "primeng/editor";
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { DialogModule } from 'primeng/dialog';
import { OrganiserService } from '../../../../data-services/organisers.service';
import { PaypalOnboardingResponse } from '../../../../data-services/models/paypal/onboarding-response.model';
import { ConfirmationService, MessageService } from 'primeng/api';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { OrganiserPaymentProvider } from '../../../../data-services/models/organisers/organiser-payment-provider.model';

@Component({
  selector: 'app-organiser-edit',
  imports: [CommonModule, FormsModule, ReactiveFormsModule, FileUploadModule, Editor, FontAwesomeModule,DialogModule],
  templateUrl: '../ui/edit.component.html',
  styleUrl: '../ui/edit.component.css',
})
export class OrganiserEditComponent implements OnInit {
  private readonly _activatedRoute = inject(ActivatedRoute);
  private readonly _authService = inject(AuthService);
  private readonly _store = inject(Store)
  private readonly _organiserService = inject(OrganiserService)
  private readonly _messageService = inject(MessageService)
  private readonly _confirmationService = inject(ConfirmationService)

  displayPaypalModal: boolean = false;
  
  organiserForm: FormGroup = new FormGroup({
    organiserName: new FormControl<string>('',[Validators.required, Validators.minLength(3)]),
    terms: new FormControl<string>(''),
    contact: new FormControl<string>('')
  })

  paypalForm: FormGroup = new FormGroup({
    account: new FormControl<string>('',[Validators.required,Validators.email])
  })

  organiser$ = this._store.select(selectAdminOrganiser(this._activatedRoute.snapshot.params['id'])).pipe(
    tap(organiser => {
      this.organiserForm.controls['organiserName'].setValue(organiser?.name)
    })
  )

  ngOnInit(): void {
    this._store.dispatch(adminActions.getOrganisers());
  }

  get apiUrl(): string {
    return `${environment.API}admin/organisers/${this._activatedRoute.snapshot.params['id']}/image`
  }

  get getHeaders(): HttpHeaders {
    const headers: HttpHeaders = new HttpHeaders();
    headers.set('authorization',`Bearer ${this._authService.currentToken}`);
    return headers;
  }

  onUpload(event:UploadEvent) {
    const response = event.originalEvent as HttpResponse<CloudinaryImg>;
    if (response.body){
      this._store.dispatch(adminApiActions.updateOrganiser({ update: {
        id: this._activatedRoute.snapshot.params['id'],
        changes: {
          image: response.body
        }
      }}))
    }
  }

  choose(event, callback) {
    callback();
  }

  connectToPayPal(){
    this._organiserService.onboardPaypalMerchant(this._activatedRoute.snapshot.params['id'], this.paypalForm.controls['account'].value).subscribe(response => {
      if (response){
        const linkResponse = response.find(x => x.rel === 'action_url')
        if (linkResponse){
          window.open(linkResponse.href,"_self");
        }
      }
    })
  }

  getPaymentProvider(name:string, providers?: OrganiserPaymentProvider[]){
    return providers?.find(x => x.paymentProvider.name === name)
  }
}
